import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtectStaffAdd.propTypes = {
  children: PropTypes.node
};

const home_url = process.env.REACT_APP_DOMAIN;

function AuthProtectStaffAdd({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();

  let staffAccessChild = user.staffAccessChild;

  
  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || (user.isStaff && !staffAccessChild.includes('staffAdd'))) {
    window.location = `${home_url}/unauthorized`
    return <LoadingScreen />
  }

  return <>{children}</>;
}

export default AuthProtectStaffAdd
